
import * as ds from '~/scriptData/ds/dsCommon'
import ProdSwiperCmp from '~/components/ds/common/ProdSwiperCmp.vue'
import ProdUnit from '~/components/ds/common/ProdUnitCmp.vue'
export default {
  name: 'FbCartItem',
  components: {
    ProdSwiperCmp,
    ProdUnit
  },
  props: {
    exhData: {
      type: Object,
      default () { return {} }
    }
  },
  data () {
    return {
      showRndBtn: false,
      cartProduct: {},
      productList: [],
      relatedItems: [],
      requestParams: {
        exhCmptmtInfo: {
          exhCmptmtId: '', // 전시파트 구좌ID
          exhMtrlNo: '', // 전시파트 소재ID
          hdcpy: '', // 구좌명
          lginYn: '', // 로그인 필요여부(개인화 여부)
          exhMtrlRgMthdCd: '', // 구좌 리스트 조회(10 : 전시파트 수기등록, 20 : 검색솔루션, 30: 추천솔루션)
          insdYn: '', // api 구분(Y : 전시파트 수기등록 or 추천솔루션, N : 검색솔루션)
          url: '' // 도메인 포함 솔루션 url 정보 (ex. env.API_BASE_URL + api url)
        },
        recmApi: {} // 추천 솔루션 옵션정보
      },
      type: ds.getProdExhType('05'),
      prodSwiperOpt: { // 상품 리스트 스와이퍼 설정
        pagination: false,
        slidesPerView: this.type.pageSize,
        slidesPerGroup: this.type.pageSize
      }
    }
  },
  computed: {
    returnExhTypeClass () {
      // 상품목록 나열 클래스 객체 생성
      const classObj = {}
      if (this.type.class.length > 0) {
        this.type.class.forEach((item) => {
          classObj[item] = true
        })
      }
      return classObj
    }
  },
  async mounted () {
    this.requestParams.recmApi = this.$store.getters['ds/getDynamicId']
    await this.loadCartItem()
    await this.loadProducts()
  },
  updated () {},
  unmounted () {},
  methods: {
    /**
     * @description : 장바구니 최근 담긴 상품 조회
     */
    async loadCartItem () {
      const isLogined = this.$store.getters['session/getMbMngNo']
      if (!isLogined) {
        throw new Error(`구좌ID : ${this.exhData.exhCmptmtId}-${this.exhData.exhMtrlNo},  비로그인 노출 제한`)
      } else {
        const cartItem = await this.$AxiosBuilder
          .data()
          .build()
          .post('/ds/spbk/recent')
          .then((res) => {
            return res.data.data
          })
        if (cartItem) {
          this.cartProduct = cartItem
        } else {
          throw new Error(`구좌ID : ${this.exhData.exhCmptmtId}-${this.exhData.exhMtrlNo}, 장바구니 상품 없음`)
        }
      }
    },
    /**
     * @description : 연관상품 추천 솔루션 조회
     */
    async loadProducts () {
      const params = {
        pdNoList: [this.cartProduct.pdNo],
        limit: this.type.maxSize + 1,
        offset: 0,
        dlvTy: this.requestParams.recmApi.fdrmOrPsblYn === 'Y' ? 'frdm' : '',
        rcTy: '7'
      }
      this.relatedItems = await this.$AxiosBuilder
        .data(params)
        .build()
        .post('/ds/recommend/related')
        .then((res) => {
          return res.data.data
        })
        .catch((e) => {
          throw new Error(`구좌ID : ${this.exhData.exhCmptmtId}-${this.exhData.exhMtrlNo} \n ${e}`)
        })
      this.productList = this.relatedItems.slice(0, this.type.maxSize)
      if (this.productList.length < this.type.minSize) {
        throw new Error(`장바구니 구좌 - 구좌번호 : ${this.exhData.exhCmptmtId}, 소재번호 : ${this.exhData.exhMtrlNo} \n 최소 노출 갯수 정책 미도달 : 현재 상품수량(${this.productList.length}), 노출 기준수량(${this.type.minSize})`)
      }
    },
    /**
     * @description: 더보기 추천셋 이동
     *  -> PC 버전에서는 더보기 버튼 제외
     */
    openRcmmSet () {
      // 파라미터 세팅하기
      const routerParams = ds.setDefaultParams(this.exhData)
      routerParams.recmApi.pdNo = this.cartProduct.pdNo
      routerParams.url = process.env.API_BASE_URL + '/ds/recommend/related'
      Object.assign(routerParams.recmApi, this.requestParams.recmApi)
      routerParams.recmApi.rcTy = '7' // 추천유형 : 장바구니 추천구좌 (함께 보면 좋은 상품)
      // 추천셋 이동
      this.$store.dispatch('ds/persisted/updateRendingSet', routerParams).then(() => {
        this.$router.push({ name: 'ds-recmd-id', params: { id: 'C206' } })
      })
    }
  }
}
